import FunctionPropsTable from "../../../../../../packages/pragmatic-drag-and-drop/flourish/examples/constellation/props-table";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHprops_table from "!!raw-loader!../../../../../../packages/pragmatic-drag-and-drop/flourish/examples/constellation/props-table";
import * as React from 'react';
export default {
  FunctionPropsTable,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHprops_table,
  React
};